import { render, staticRenderFns } from "./WriteDoctor.vue?vue&type=template&id=31674384&scoped=true"
import script from "./WriteDoctor.vue?vue&type=script&lang=js"
export * from "./WriteDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31674384",
  null
  
)

export default component.exports